
synchronizerFactory = ($q, $timeout, Debouncer) ->
    'ngInject'

    class Synchronizer extends Debouncer

        constructor: (delay) ->
            @promises = []
            super(@wait, delay)

        wait: =>
            return $q.all(@promises).then => @promises = []

        sync: (promise) =>
            deferred = $q.defer()
            @promises.push promise
            @call().then -> deferred.resolve(promise)
            return deferred.promise


    return Synchronizer


module.factory 'Synchronizer', synchronizerFactory
